<template>
  <div>
    <Particles
      id="tsparticles"
      :options="{
              background: {
                  color: {
                      value: '#0f1123'
                  }
              },
              fpsLimit: 60,
              interactivity: {
                  detectsOn: 'canvas',
                  events: {
                      resize: true
                  },
                  modes: {
                      bubble: {
                          distance: 400,
                          duration: 2,
                          opacity: 0.8,
                          size: 40
                      },
                      push: {
                          quantity: 4
                      },
                      repulse: {
                          distance: 200,
                          duration: 0.4
                      }
                  }
              },
              particles: {
                  color: {
                      value: '#55ffdc'
                  },
                  links: {
                      color: '#103c44',
                      distance: 150,
                      enable: true,
                      opacity: 0.5,
                      width: 1
                  },
                  collisions: {
                      enable: true
                  },
                  move: {
                      direction: 'none',
                      enable: true,
                      outMode: 'bounce',
                      random: false,
                      speed: 6,
                      straight: false
                  },
                  number: {
                      density: {
                          enable: true,
                          value_area: 800
                      },
                      value: 80
                  },
                  opacity: {
                      value: 0.5
                  },
                  shape: {
                      type: 'circle'
                  },
                  size: {
                      random: true,
                      value: 5
                  }
              },
              detectRetina: true
          }"/>
    <div class="p-login">
      <v-container>
        <v-layout row wrap justify-center>
          <v-flex sm5 xs12>
            <div class="login-header">
              <div class="logo-block">
                <img class="login-logo" src="../assets/img/logos/logo-white.png" alt="">
              </div>
              <h1>Sign In To Admin</h1>
            </div>
            <div class="login-block animated-el-0">
              <form @submit.prevent="login()">
                <i-text-field
                  solo
                  class="animated-el-1"
                  prepend-icon="person"
                  type="text"
                  name="username-field"
                  placeholder="Username"
                  v-model="username"
                />
                <i-text-field
                  solo
                  class="animated-el-2"
                  prepend-icon="lock"
                  type="password"
                  name="password-field"
                  placeholder="Password"
                  v-model="password"
                />
                <v-layout align-center mt-2>
                </v-layout>
                <v-layout justify-center mt-4>
                  <i-btn class="animated-el-3" type="submit" color="primary" :disabled="loginRequestPending">
                    <template v-if="!loginRequestPending">
                      Sign In
                    </template>
                    <v-progress-circular
                      v-else
                      :size="17"
                      :width="2"
                      indeterminate
                      color="white"
                    ></v-progress-circular>
                  </i-btn>
                </v-layout>
              </form>
              <transition name="slide-fade" mode="out-in">
                <p v-if="invalid" class="error--text text-xs-center mt-4">Login failed: Invalid username or password</p>
              </transition>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Particles from 'particles.vue'

Vue.use(Particles)

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      invalid: false,
      loginRequestPending: false
    }
  },
  methods: {
    login () {
      if (this.email !== '' && this.password !== '') {
        this.loginRequestPending = true
        this.$store.dispatch('auth/getUser', {
          username: this.username,
          password: this.password
        }).then((res) => {
          if (res === 1) {
            // Get Color
            this.$store.dispatch('auth/getThemeColor')
            // Get Params
            this.$store.dispatch('auth/getAccountParams').then(() => {
              this.loginRequestPending = false
              this.$router.replace('/dashboard')
            })
          } else {
            this.loginRequestPending = false
            this.invalid = true
          }
        })
      }
    }
  },
  computed: {
    invalidUser () {
      return this.$store.state.auth.invalidUser
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/pages/login";
</style>



// WEBPACK FOOTER //
// src/views/Login.vue